<template>
  <div class="bottom-content mb-4">
    <div class="logo-content">
      <img src="img/swampum-logo.png" alt="Swampum" class="logo" />
      <h4>Swampum LLC</h4>
    </div>
    <div class="register-content">
      <SButtonMaterial
        class="register-button"
        buttonType="button"
        textColor="white"
        size="lg"
        color="primary"
        materialClass="dense"
        text="REGISTER"
        to="/signup"
      />
    </div>
  </div>
</template>

<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";

export default {
  name: "SLandingBottomContent",
  components: {
    SButtonMaterial,
  },
};
</script>

<style scoped>
.bottom-content {
  width: 72rem;
  height: 200px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  place-content: center;
  color: #fff;
  margin: auto;
  border-radius: 4px;
}
.logo-content,
.register-content {
  width: 50%;
  height: 50%;
}
.logo-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
  position: relative;
  right: 10%;
}
.logo {
  width: 180px;
  height: 70px;
}
.register-button {
  width: 442px;
  height: 49px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
  border-radius: 1rem;
  margin-top: 1.28em;
  font-size: 24px !important;
}
@media screen and (max-width: 1023px) {
  .bottom-content {
    flex-direction: column;
  }
  .logo-content {
    right: 0%;
  }
  .logo-content,
  .register-content {
    width: 100%;
  }
  .register-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: nowrap;
    align-content: stretch;
  }
  .register-button {
    width: 90% !important;
  }
}
</style>

<style lang="scss" scoped>
.bottom-content {
  background-color: $background-primary-2;
}
</style>
